import React from "react";
import { MdOutlineNotificationsNone } from "react-icons/md";

export default function ButtonPushSubscribe() {
  return (
		<MdOutlineNotificationsNone className="nav-icon" />
  )
}